<template>
    <Menu as="div" class="relative">
        <div>
            <MenuButton
            class="inline-flex items-center justify-center rounded-xl bg-primary-500 p-3 text-sm text-white"
            >
                Actions
                <ChevronDownIcon
                    class="ml-2 h-3 w-3"
                    aria-hidden="true"
                />
            </MenuButton>
        </div>

        <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
        >
            <MenuItems
            class="absolute right-0 z-50 mt-2 max-w-fit origin-top-right rounded-md bg-white shadow-lg border border-gray-300"
            >
                <div class="" v-for="i in menu" :key="i">
                    <div v-if="i.allowed">
                        <MenuItem v-slot="{ active }"
                        @click="$emit('click-menu', i.name)">
                            <button
                                :class="[
                                active ? 'bg-gray-200' : 'text-gray-900',
                                'group flex w-full whitespace-nowrap items-center text-sm px-6 py-3',
                                ]"
                            >
                                {{ i.name }}
                            </button>
                        </MenuItem>
                    </div>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/24/solid'

defineProps({
    menu: {
        type: Object,
        default: () => ({})
    },
});
</script>